import { PageContainer, PageContentView } from 'components/shared';

import { BCMSDate, useBCMSContext, useStateManager, BCMSRecord, BCMSStateManagerCRUD } from "bcms-react";
import Classes, { Participant, ParticipantImportTemplate, PassThruHistory } from "model";
import React from 'react';
import ImportParticipantsCSVFileWidget from './components/ImportParticipantsCSVFileWidget';
import ImportParticipantsNACHAFileWidget from './components/ImportParticipantsNACHAFileWidget';
import ParticipantImportTemplatesWidget from './components/ParticipantImportTemplatesWidget';
import "./mobile.css";
import "./styles.css";

/**
 * @function ImportACHPage
 * @return {React.Component}
 * @exported true
 * @description The page for imported ACH
 */

export default function ImportACHPage(props) {
  const globalController = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, globalController);

  const data = { ...getDefaultData(), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,
    updateImportTemplates: value =>{
      BCMSStateManagerCRUD.init(state)
      .update(["data", "participantImportTemplatesWidgetData", "template"], ParticipantImportTemplate.init({}))
      .update(["data", "participantImportTemplatesWidgetData", "importTemplates"], value)
      .update(["data", "importParticipantsCSVFileWidgetData", "importTemplates"], value)

      .submit(setState);
    }
  });

  return (
    <PageContainer className="import-ach-page" state={{ data, ui }} controller={controller}>
      <PageContent />
    </PageContainer>
  );
}

// No data changes for now.
export const getDefaultData = () => ({

  participantImportTemplatesWidgetData: {
    template: ParticipantImportTemplate.init({}),
    importTemplates: ParticipantImportTemplate.initAll(),
  },
  importParticipantsCSVFileWidgetData: {
    selectedTemplate: "select",
    fileName:"Payroll.csv",
    importTemplates: ParticipantImportTemplate.initAll(),
  },
  importParticipantsNACHAFileWidgetData: {
    fileName:"Payroll_NACHA.csv",
  }
});

// Few ui changes for now.
export const getDefaultUI = () => ({
  participantImportTemplatesWidgetUI: {
    showAddTemplateFormView: false,
    showMatchCriteria: true
  },
  importParticipantsCSVFileWidgetUI: {
    isFileChosen: false,
    isFileUploaded: false,
    showFileUploadedBanner: false,
    participantImportTemplateSelect: { isActive: false }
  },
  importParticipantsNACHAFileWidgetUI: {
    isFileChosen: false,
    isFileUploaded: false,
    showFileUploadedBanner: false
  }
});

function PageContent(props) {
  const { data, ui, updateImportTemplates} = useStateManager();
  const actions = {
    updateImportTemplates
  }

  return (
    <PageContentView>
      <div className="flex-container flex-vertical flex-width">
        <ParticipantImportTemplatesWidget data={data.participantImportTemplatesWidgetData}
          ui={ui.participantImportTemplatesWidgetUI} actions={actions}/>
        <ImportParticipantsCSVFileWidget data={data.importParticipantsCSVFileWidgetData}
          ui={ui.importParticipantsCSVFileWidgetUI} actions={actions}/>
        <ImportParticipantsNACHAFileWidget data={data.importParticipantsNACHAFileWidgetData}
          ui={ui.importParticipantsNACHAFileWidgetUI} />
      </div>
    </PageContentView>
  );
}